import {Component, Input, TemplateRef, ViewChild} from '@angular/core';
import {AuthService} from "../../services/auth/auth.service";
import {MatDialog} from "@angular/material/dialog";
import {TicketControlService} from "../../services/ticket-control/ticket-control.service";

@Component({
  selector: 'app-event-qr-code-control',
  templateUrl: './event-qr-code-control.component.html',
  styleUrls: ['./event-qr-code-control.component.scss']
})
export class EventQrCodeControlComponent {
  @ViewChild('qrCodeDialog')
  qrCodeDialog: TemplateRef<any>;

  @Input() eventId: number;
  @Input() eventName: string;
  @Input() ownerCentreId: number;

  public isLoading: boolean;
  public svg: string;

  get canSee(): boolean {
    return this.authService.checkPrivileges('ticket_control_show_integration_qr') && this.authService.user?.centreId === this.ownerCentreId;
  }

  constructor(public authService: AuthService,
              public dialog: MatDialog,
              private ticketControlService: TicketControlService) {}

  public showQR(): void {
    const dialogRef = this.dialog.open(this.qrCodeDialog, {
      width: '60%'
    });
    dialogRef.afterOpened().subscribe(() => {
      this.isLoading = true;
      this.ticketControlService.getEventQrCode(this.eventId).subscribe((svg ) => {
        if (svg.size) {
          this.svg = URL.createObjectURL(svg);
          this.isLoading = false;
        }
      });
    });
  }
}
